import { render, staticRenderFns } from "./grabfood.vue?vue&type=template&id=19b40695&scoped=true&"
import script from "./grabfood.vue?vue&type=script&lang=js&"
export * from "./grabfood.vue?vue&type=script&lang=js&"
import style0 from "./grabfood.vue?vue&type=style&index=0&id=19b40695&prod&scoped=true&lang=css&"
import style1 from "./grabfood.vue?vue&type=style&index=1&id=19b40695&prod&lang=scss&scoped=true&"
import style2 from "./grabfood.vue?vue&type=style&index=2&id=19b40695&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b40695",
  null
  
)

export default component.exports